import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

export const fileUrl = (storagePath) => {
  if (!storagePath) return "";
  if (storagePath.startsWith("http")) return storagePath;
  return `${API}/files/${storagePath}`;
};

/** Download an authenticated PDF and open it in a new tab. */
export const openPdf = async (path, filename = "cotizacion.pdf") => {
  const res = await http.get(path, { responseType: "blob" });
  const blob = new Blob([res.data], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const w = window.open(url, "_blank");
  if (!w) {
    // Popup blocked → fall back to same-tab download
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  // Revoke later so tab has time to load
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
};

export const CURRENCIES = [
  { code: "USD", label: "USD · Dólar", symbol: "US$" },
  { code: "EUR", label: "EUR · Euro", symbol: "€" },
  { code: "ARS", label: "ARS · Peso argentino", symbol: "AR$" },
  { code: "BRL", label: "BRL · Real brasileño", symbol: "R$" },
  { code: "CLP", label: "CLP · Peso chileno", symbol: "CLP$" },
];

export const currencySymbol = (code) =>
  CURRENCIES.find((c) => c.code === code)?.symbol || code;

export const fmtMoney = (n, code) => {
  const num = Number(n || 0);
  return `${currencySymbol(code)} ${num.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
